var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPfa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 318.965 318.965",
    style: {
      enableBackground: "new 0 0 318.965 318.965"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#636358"
    },
    d: "M303.673,253.518c-11.151-37.754-67.121-33.566-91.279-44.408 c-24.157-10.842-20.386-47.219-23.449-53.548h-58.932c-3.058,6.329,0.714,42.711-23.449,53.548 c-24.157,10.842-80.133,6.655-91.279,44.408c-6.149,20.824-5.857,27.193-7.554,50.26c0,0,76.8,15.187,150.014,15.187 s153.488-15.187,153.488-15.187C309.53,280.705,309.822,274.342,303.673,253.518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#515147"
    },
    d: "M303.673,253.518c-11.151-37.754-67.121-33.566-91.279-44.408 c-24.157-10.842-20.386-47.219-23.449-53.548H157.74c0,0-0.719,51.024,23.438,61.866s80.133,6.655,91.279,44.408 c5.857,19.83,5.868,26.552,7.324,47.073c19.234-2.816,31.442-5.126,31.442-5.126C309.53,280.705,309.822,274.342,303.673,253.518z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEAE1"
    },
    d: "M174.748,318.7c10.348-26.67,24.163-73.95,26.366-119.466h-83.427 c2.203,45.572,16.058,92.909,26.423,119.562c4.541,0.112,9.094,0.169,13.636,0.169 C163.383,318.964,169.065,318.863,174.748,318.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C6C5AF"
    },
    points: "196.91,216.225 176.108,236.122 171.19,205.743  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C6C5AF"
    },
    points: "121.009,216.225 142.817,236.122 146.796,205.518  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C6C5AF"
    },
    points: "172.005,205.518 146.796,205.518 144.885,211.7 173.961,211.869  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AAA88F"
    },
    points: "146.796,205.518 144.885,211.7 145.987,212.42  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AAA88F"
    },
    points: "173.961,211.869 171.19,205.743 172.331,212.802  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4C4C4C"
    },
    d: "M173.433,318.739l0.579-7.987l-6.081-80.51h-16.024l-7.099,80.515l0.585,8.066 c4.12,0.084,8.24,0.141,12.354,0.141C162.95,318.964,168.188,318.88,173.433,318.739z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3A3A38"
    },
    points: "151.967,230.597 167.93,230.237 168.256,234.734  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4C4C4C"
    },
    points: "140.541,208.182 178.255,208.159 176.108,221.031 167.593,230.597 151.967,230.597  142.693,221.031  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEAE1"
    },
    d: "M146.796,205.518l-25.72-13.984c0,0-3.389,4.817-11.843,16.21l31.723,22.853l2.704-14.923 L146.796,205.518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEAE1"
    },
    d: "M171.122,205.518l25.72-13.984c0,0,3.389,4.817,11.843,16.21l-31.723,22.853l-2.704-14.923 L171.122,205.518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0DBD3"
    },
    d: "M196.842,191.534l-25.72,13.984l1.776,5.772c2.372,2.602,5.109,4.716,8.279,6.138 c2.799,1.253,6.02,2.31,9.549,3.249l17.947-12.927C200.232,196.351,196.842,191.534,196.842,191.534z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#515147"
    },
    d: "M233.292,250.73l-15.333-5.559l13.776-3.794l-13.13-29.969l-40.749,107.208 c4.778-0.163,9.549-0.377,14.293-0.635L233.292,250.73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#515147"
    },
    d: "M86.189,241.372l13.776,3.794l-15.333,5.559l41.216,67.369c4.716,0.247,9.471,0.444,14.237,0.59 L99.24,211.734L86.189,241.372z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#72726A"
    },
    d: "M228.981,251.562l-14.833-6.239l13.461-4.783l-9.004-29.137l-16.907-13.147l-32.111,120.579 c6.97-0.146,13.962-0.41,20.903-0.776L228.981,251.562z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#636358"
    },
    d: "M201.693,198.256l-6.278,23.567c8.538,1.945,18.385,3.507,28.171,5.711l-4.985-16.131 L201.693,198.256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#72726A"
    },
    d: "M99.235,211.74l-8.926,28.806l13.461,4.783l-14.833,6.239l38.563,66.621 c6.902,0.343,13.877,0.585,20.847,0.703L116.22,198.267L99.235,211.74z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.177 0.9842 -0.9842 -0.177 385.6561 -85.3711)",
    style: {
      fill: "#CCA483"
    },
    cx: 228.522,
    cy: 118.558,
    rx: 21.386,
    ry: 11.629
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.9842 0.177 -0.177 -0.9842 200.0903 219.2807)",
    style: {
      fill: "#DBB491"
    },
    cx: 90.265,
    cy: 118.565,
    rx: 11.629,
    ry: 21.386
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBB491"
    },
    d: "M223.641,47.365H159.42H95.233c0,0-35.989,146.614,64.187,160.806 C259.636,193.979,223.641,47.365,223.641,47.365z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCA483"
    },
    d: "M159.42,208.171c100.216-14.192,64.221-160.806,64.221-160.806h-15.024 c4.114,61.242,9.808,93.774-13.815,129.24C176.085,204.708,159.42,208.171,159.42,208.171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#393C3D"
    },
    d: "M187.838,5.48c0,0-19.824-9.33-46.477-3.642c-19.953,4.26-52.423,17.829-59.73,46.893 c0,0-10.932,47.483,7.683,67.931c0,0-0.916-18.548,0.956-33.313c0,0,11.174,4.946,33.69,4.659 c30.188-0.382,59.444-12.776,68.442-26.355c0,0-1.034,19.532-10.876,27.502c0,0,34.522-5.396,44.729-25.883 c0,0,3.417,17.935,3.417,51.159c0,0,5.39-7.509,6.649-19.605c2.855-27.44-2.333-65.334-22.876-64.069 C213.446,30.756,204.745,13.49,187.838,5.48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCA483"
    },
    d: "M181.526,89.154c9.836-7.976,10.876-27.502,10.876-27.502 c-8.999,13.574-38.248,25.967-68.442,26.355c-21.763,0.275-32.931-4.333-33.651-4.643c1.433,0.613,44.156,18.554,91.672-3.884 c0,0-2.58,9.527-8.139,12.804c0,0,43.869-0.793,52.418-29.008C216.054,83.758,181.526,89.154,181.526,89.154z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPfa);
export default __webpack_public_path__ + "static/media/PFA.f7d4f5bfa135b948e416db7d950a0b56.svg";
export { ForwardRef as ReactComponent };